import { useContext } from 'react';

import { ThemeContext } from '@app/contexts/ThemeContext';

export type ThemeMode = 'light' | 'dark' | 'system';
export type ColorTheme =
  | 'lavender-mist'
  | 'soft-cloud'
  | 'paper-white'
  | 'classic'
  // Seasonal themes — user-selectable; each layers a backdrop + ambient effect.
  | 'winter'
  | 'halloween'
  | 'cherry-blossom'
  | 'fall'
  | 'patriotic'
  | 'st-patricks';

interface ThemeContextType {
  themeMode: ThemeMode;
  effectiveTheme: 'light' | 'dark'; // The actual theme being applied
  colorTheme: ColorTheme;
  setThemeMode: (mode: ThemeMode) => void;
  setColorTheme: (theme: ColorTheme) => void;
  toggleDarkMode: () => void; // Keep for backward compatibility with DarkModeToggle
}

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
